import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const PADDLE_TOKEN = process.env.REACT_APP_PADDLE_TOKEN;
const PADDLE_PRICE_ID = process.env.REACT_APP_PADDLE_PRICE_ID;

const loadPaddle = () => new Promise((resolve) => {
  if (window.Paddle) {
    if (!window.Paddle._initialized) {
      window.Paddle.Initialize({ token: PADDLE_TOKEN });
      window.Paddle._initialized = true;
    }
    resolve(window.Paddle);
    return;
  }
  const script = document.createElement('script');
  script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js';
  script.onload = () => {
    window.Paddle.Initialize({ token: PADDLE_TOKEN });
    window.Paddle._initialized = true;
    resolve(window.Paddle);
  };
  document.head.appendChild(script);
});

export default function Paywall({ session, onSubscribed }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPaddle();
  }, []);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const paddle = await loadPaddle();
      paddle.Checkout.open({
        items: [{ priceId: PADDLE_PRICE_ID, quantity: 1 }],
        customer: { email: session.user.email },
        customData: { user_id: session.user.id },
        settings: {
          successUrl: window.location.href,
        },
      });

      // Poll for subscription after checkout opens
      const poll = setInterval(async () => {
        const { data } = await supabase
          .from('subscriptions')
          .select('*')
          .eq('user_id', session.user.id)
          .in('status', ['active', 'trialing'])
          .single();
        if (data) {
          clearInterval(poll);
          onSubscribed();
        }
      }, 3000);

      // Stop polling after 5 minutes
      setTimeout(() => clearInterval(poll), 300000);

    } catch (err) {
      console.error('Paddle checkout error:', err);
    }
    setLoading(false);
  };

  const style = `
    .paywall-overlay {
      position: absolute;
      bottom: 0; left: 0; right: 0;
      z-index: 20;
      background: linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.65) 60%, transparent 100%);
      padding: 48px 32px 32px;
      display: flex; flex-direction: column; align-items: center; gap: 12px;
      text-align: center;
    }
    .paywall-title {
      font-family: 'Fraunces', serif; font-weight: 900;
      font-size: clamp(20px, 3vw, 32px); color: #fff;
      line-height: 1.1; text-shadow: 0 2px 8px rgba(0,0,0,0.5);
    }
    .paywall-title em { font-style: italic; color: #C4B5FD; }
    .paywall-sub {
      font-size: 15px; color: rgba(255,255,255,0.75);
      max-width: 420px; line-height: 1.5;
    }
    .paywall-btn {
      display: flex; align-items: center; gap: 10px;
      background: linear-gradient(135deg, #8B5CF6, #38BDF8);
      color: #fff; border: none; border-radius: 100px;
      padding: 16px 40px;
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-weight: 700; font-size: 16px; cursor: pointer;
      box-shadow: 0 8px 32px rgba(139,92,246,0.5);
      transition: opacity 0.2s, transform 0.2s;
      margin-top: 4px;
    }
    .paywall-btn:hover { opacity: 0.9; transform: translateY(-2px); }
    .paywall-btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
    .paywall-guarantee {
      font-size: 12px; color: rgba(255,255,255,0.45);
      display: flex; align-items: center; gap: 6px;
    }
  `;

  return (
    <>
      <style>{style}</style>
      <div className="paywall-overlay">
        <div className="paywall-title">
          Your vault is <em>ready.</em>
        </div>
        <div className="paywall-sub">
          Unlock it for $69/year and give your family the peace of mind they deserve.
        </div>
        <button className="paywall-btn" onClick={handleCheckout} disabled={loading}>
          🔓 {loading ? 'Opening checkout...' : 'Unlock My Vault — $69/year'}
        </button>
        <div className="paywall-guarantee">
          🛡️ 30-day money-back guarantee · Secure checkout by Paddle
        </div>
      </div>
    </>
  );
}
